export interface TipoDefinicionJSON {
  td_id: string | null;
  td_nombre: string;
  td_descripcion: string;
}

export class TipoDefinicion {
  protected constructor(private id: string | null, private nombre: string, private descripcion: string) {}

  static createFrom(id: string | null, nombre: string, descripcion: string) {
    return new this(id, nombre, descripcion);
  }

  isIdentifiedBy(anId: string): boolean {
    return +this.id! === +anId;
  }

  isIdentifiedAs(aEntity: TipoDefinicion) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: TipoDefinicionJSON) {
    return TipoDefinicion.createFrom(entity.td_id, entity.td_nombre, entity.td_descripcion);
  }

  toJSON(): TipoDefinicionJSON {
    return {
      td_id: this.getId(),
      td_nombre: this.getNombre(),
      td_descripcion: this.getDescripcion(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getDescripcion(): string {
    return this.descripcion;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setDescripcion(value: string): void {
    this.descripcion = value;
  }
}
